import {
  TMDX_JET_AVIA_MODIFIED_FIELDS_LIST,
  SUPPLEMENTAL_LIFT_AVIA_MODIFIED_FIELDS_LIST,
  TX_CENTER_AVIA_MODIFIED_FIELDS_LIST,
  COMMERCIAL_AVIA_MODIFIED_FIELDS_LIST,
  TMDX_AFFILIATE_GROUND_MODIFIED_FIELDS_LIST,
  TX_CENTER_GROUND_MODIFIED_FIELDS_LIST,
  DEVICE_DELIVERY_GROUND_MODIFIED_FIELDS_LIST,
  ACCOMMODATION_MODIFIED_FIELDS_LIST,
  TMDX_DRIVE_GROUND_MODIFIED_FIELDS_LIST,
  SELF_SERVICED_GROUND_MODIFIED_FIELDS_LIST,
  GROUND_TRIP_REASSIGNED_FIELDS_LIST,
} from '@lp/features/RoutePlanner/components/LogisticsChangeLog/consts';
import {
  FieldItem,
  getChangeEventValues,
  ModifiedLogValue,
  ModifiedValue,
} from '@lp/features/RoutePlanner/components/LogisticsChangeLog/utils';
import {
  AccommodationLegModifiedLog,
  EventOperationType,
  GroundTripReassignedLog,
  LogisticsChangeLogType,
  ModifiedEventLogType,
  ModifiedLogisticsChangeLog,
  ModifiedLogLegType,
} from '@/api/apis/route';

const getFieldsChanges = <T, R extends PropertyKey = never>(
  id: string,
  logType: LogisticsChangeLogType,
  leg: ModifiedEventLogType<ModifiedLogLegType<T>, R>,
  list: FieldItem[],
): ModifiedValue<ModifiedLogValue | null>[] => {
  return list
    .map(({ fieldName, fields, converter }) => {
      const changedModel = getChangeEventValues(id, leg, fields as (keyof T & keyof typeof leg)[]);

      return {
        id: changedModel.id,
        fieldName,
        operationType: changedModel.operationType,
        changes:
          changedModel.operationType === EventOperationType.NoChange
            ? []
            : converter(changedModel.oldValue, changedModel.newValue, logType, fields),
      };
    })
    .filter((item) => item.operationType !== EventOperationType.NoChange);
};

export const getModifiedFieldValues = (
  log: ModifiedLogisticsChangeLog | AccommodationLegModifiedLog | GroundTripReassignedLog,
): ModifiedValue<ModifiedLogValue | null>[] => {
  switch (log.$type) {
    case LogisticsChangeLogType.TmdxJetAviaLegModifiedLog:
      return getFieldsChanges(log.id, log.$type, log.leg, TMDX_JET_AVIA_MODIFIED_FIELDS_LIST);
    case LogisticsChangeLogType.SupplementalLiftAviaLegModifiedLog:
      return getFieldsChanges(log.id, log.$type, log.leg, SUPPLEMENTAL_LIFT_AVIA_MODIFIED_FIELDS_LIST);
    case LogisticsChangeLogType.TxCenterProviderAviaLegModifiedLog:
      return getFieldsChanges(log.id, log.$type, log.leg, TX_CENTER_AVIA_MODIFIED_FIELDS_LIST);
    case LogisticsChangeLogType.CommercialFlightAviaLegModifiedLog:
    case LogisticsChangeLogType.SabreCommercialAviaLegModifiedLog:
      return getFieldsChanges(log.id, log.$type, log.leg, COMMERCIAL_AVIA_MODIFIED_FIELDS_LIST);
    case LogisticsChangeLogType.TmdxAffiliateGroundLegModifiedLog:
      return getFieldsChanges(log.id, log.$type, log.leg, TMDX_AFFILIATE_GROUND_MODIFIED_FIELDS_LIST);
    case LogisticsChangeLogType.TxCenterProviderGroundLegModifiedLog:
      return getFieldsChanges(log.id, log.$type, log.leg, TX_CENTER_GROUND_MODIFIED_FIELDS_LIST);
    case LogisticsChangeLogType.CurriServiceGroundLegModifiedLog:
      return getFieldsChanges(log.id, log.$type, log.leg, DEVICE_DELIVERY_GROUND_MODIFIED_FIELDS_LIST);
    case LogisticsChangeLogType.AccommodationLegModifiedLog:
      return getFieldsChanges(log.id, log.$type, log.leg, ACCOMMODATION_MODIFIED_FIELDS_LIST);
    case LogisticsChangeLogType.GroundTripToAffiliateLegReassignedLog:
    case LogisticsChangeLogType.GroundTripToTedsLegReassignedLog:
      return getFieldsChanges(log.id, log.$type, log.leg, GROUND_TRIP_REASSIGNED_FIELDS_LIST);
    case LogisticsChangeLogType.TmdxDriveAffiliateGroundLegModifiedLog:
    case LogisticsChangeLogType.TmdxDriveTedsGroundLegModifiedLog:
      return getFieldsChanges(log.id, log.$type, log.leg, TMDX_DRIVE_GROUND_MODIFIED_FIELDS_LIST);
    case LogisticsChangeLogType.SelfServicedGroundLegModifiedLog:
      return getFieldsChanges(log.id, log.$type, log.leg, SELF_SERVICED_GROUND_MODIFIED_FIELDS_LIST);
    default:
      return [];
  }
};
